import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { Typography } from '@material-ui/core';

import { formatPeso, disablePeso } from '../../utils';

function getDados(dados) {
  const peso = disablePeso(dados.produto) ? formatPeso(dados.peso) : '-';
  return peso;
}

const PesoField = ({ ...props }) => {
  const record = useRecordContext(props);

  const label = record ? (record.record ? getDados(record.record) : '-') : '-';

  return (
    <div>
      <Typography variant="subtitle1">{label}</Typography>
    </div>
  );
};

export default PesoField;
